import { FC } from 'react';
import SelectGroup from '../SelectGroup';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { SelectGroupProps } from '../SelectGroup/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormSelectGroupProps extends BaseSearchFormItemProps {
  /** selectGroup Props */
  selectGroupProps?: SelectGroupProps;
}
/** 分组下拉 */
export const SearchFormSelectGroup: FC<SearchFormSelectGroupProps> = props => {
  const {
    selectGroupProps,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || selectGroupProps?.disabled}
      name={name}
      label={label}
      rules={rules}
    >
      {isDetail || (selectGroupProps && selectGroupProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          name={name}
          render={render || disabledRender}
          isTable={isTable}
        />
      ) : (
        <SelectGroup
          test-id={`${testId}-${name}`}
          {...selectGroupProps}
          placeholder={getSelectPlaceholder(label, selectGroupProps, rules)}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormSelectGroup.displayName = SearchFormItemEnum.SearchFormSelectGroup;

export default SearchFormSelectGroup;
